import { Divider, Modal, Paper, Stack, Typography } from '@mui/material';
import React, { useRef, useEffect } from 'react';
import moment from 'moment';
import 'react-h5-audio-player/lib/styles.css';
import ReactAudioPlayer from 'react-audio-player';
import { RiDeleteBin6Line, RiSkipLeftLine, RiSkipRightLine } from 'react-icons/ri';
import { FiDownload } from 'react-icons/fi';
import { AppColors } from '../../../Utils/helper/AppColors';
import UserThumbnail from '../../../Components/User/UserThumbnail';
import { decryptIt } from '../../../Utils/helper/commonUtils';
import { CloseIcon } from '../../../Components/Icons/Icons';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	outline: 'none',
	padding : '15px',
	    width: '60%', // 60% of viewport width
    maxWidth: 800, // Maximum width in pixels
    minWidth: 400, // Minimum width in pixels
};

export default function PlayingModal({ open, onClose, selected }) {
	// console.log('selected', selected);
	const Icon = ({ bgcolor, icon }) => (
		<Stack
			sx={{ cursor: 'pointer', alignItems: 'center', justifyContent: 'center', svg: { fontSize: 20 } }}
			height={40}
			width={40}
			borderRadius={50}
			bgcolor={bgcolor}
		>
			{icon}
		</Stack>
	);

	const audioUrl = decryptIt(selected?.call?.artifact?.recordingUrl);
	const userName = selected?.name ? selected.name.replace(/\s+/g, '_') : 'recording';

	const messages = selected?.call?.transcript?.split('\n').filter((msg) => msg.trim() !== ''); // Split by new line and filter out empty messages
	// console.log('messages', messages);

	function downloadRecording(url, filename) {
		fetch(url)
			.then((response) => response.blob())
			.then((blob) => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = filename;
				document.body.appendChild(link);
				link.click();
				link.remove();
			});
	}

	const audioRef = useRef(null);

	useEffect(() => {
		const interval = setInterval(() => {
			if (audioRef.current && audioRef.current.audioEl && audioRef.current.audioEl.current) {
				audioRef.current.audioEl.current.removeAttribute('title');
				clearInterval(interval); // Stop checking once done
			}
		}, 100); // Check every 100ms

		return () => clearInterval(interval);
	}, []);

	return (
		<Modal open={open} onClose={onClose}>
			<Stack
				p={3}
				gap={1}
				sx={(theme) => ({ ...style, backgroundColor: theme.palette.primary.lightest_shade, borderRadius: '10px' })}
			>
				{/* <UserThumbnail size={100} vertical user={{ firstName: selected?.name }} />


				<Stack direction="row" justifyContent="center" alignItems="center" gap={3}>
					<Typography variant="subtitle2">{moment(selected?.call?.startedAt).format('MMM DD, YY')}</Typography>
					<Typography variant="subtitle2">{moment(selected?.call?.startedAt).format('hh:mm A')}</Typography>
				</Stack> */}

				<Typography variant="h6" mb={2} color="primary">
              Call Transcript
            </Typography>

            <Stack spacing={1.5} sx={{ maxHeight: '300px', overflowY: 'auto', mb: 2 }}> 
              {messages && messages.map((msg, i) => (
                <Paper
                  key={i}
                  sx={theme => ({
                    p: 1.5,
                    maxWidth: '80%',
                    bgcolor: i % 2 === 0 ? "#fff" : theme.palette.primary.lightest_shade, // Made the background color lighter
                    color: i % 2 === 0 ? "#000" : theme.palette.primary.darker_primary, // Adjusted text color for better contrast
                    alignSelf: i % 2 === 0 ? 'flex-start' : 'flex-end',
                  })}
                  elevation={1}
                >
                  <Typography variant="body2">{msg}</Typography>
                </Paper>
              ))}
            </Stack>

				<Stack direction="row" justifyContent="space-between" alignItems="center" gap={3}>
					<Typography sx={{ fontWeight: 600, color: AppColors.BLACK , fontSize: 18  }} variant="subtitle2">
						{selected?.name}
					</Typography>
					<Stack direction="row" alignItems="center" gap={1}>
					<Typography sx={{ fontWeight: 700, color: '#35373F' , fontSize: 10  }} >{moment(selected?.call?.startedAt).format('hh:mm A')}</Typography>
					<Typography sx={{ fontWeight: 700, color: '#35373F' , fontSize: 10  }}>{moment(selected?.call?.startedAt).format('DD MMMM YYYY')}</Typography>
				</Stack></Stack>

				<ReactAudioPlayer title={selected?.name || "audio"} className='audio-custom' src={audioUrl} autoPlay controls ref={audioRef} style={{ width: '100%' }} />
				{/* <Stack mt={2} direction="row" alignItems="center" justifyContent="center">
					<Icon
						bgcolor="#ECFDF3"
						icon={
							<CloseIcon
								color="#067647"
								style={{ cursor: 'pointer' }}
								onClick={() => downloadRecording(audioUrl, `${userName}.mp3`)}
							/>
						}
					/>
				</Stack> */}

				{/* <Stack mt={2} direction="row" alignItems="center" justifyContent="space-around">
					<Icon bgcolor="#F4EBFF" icon={<RiSkipLeftLine color="#667085" />} />
					<Icon
						bgcolor="#ECFDF3"
						icon={<FiDownload color="#067647" />}
						onClick={() => downloadRecording(audioUrl, `${userName}.mp3`)}
					/>
					<Icon bgcolor="#FEF3F2" icon={<RiDeleteBin6Line color="#B42318" />} />
					<Icon bgcolor="#F4EBFF" icon={<RiSkipRightLine color="#667085" />} />
				</Stack> */}
			</Stack>
		</Modal>
	);
}
